import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  root: {
    width: '100%',
    textAlign:'center'
  },
  FormLabel: {},
  RadioGroup: {
    flexDirection: 'row',
    justifyContent:'center'
  },
}));
